/* eslint-disable prettier/prettier */
export default [
  '<div class="tip tip-hide">',
      '<div class="tip-arrow"></div>',
      '<div class="tip-inner"></div>',
  '</div>'
].join('');
